import useGenerateReport from "../../../Components/hooks/useGenerateReport";

export default useGenerateReport;
